import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';

export const getInsightRevenue: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/insight/revenue_active',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getInsightRevenueXh: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/xh/insight/revenue_active',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getInsightRentention: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/insight/new_d2',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getInsightRententionXh: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/xh/insight/new_d2',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getKeyMetricsTrendData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/metrics/dau_new_revenue_trend',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getKeyMetricsTrendDataXh: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/xh/metrics/dau_new_revenue_trend',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getKeyMetricsTrendRetentionData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/metrics/retention_trend',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getKeyMetricsTrendRetentionDataXh: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/xh/metrics/retention_trend',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

export const getKeyMetricsPerformance: (data: any, language:string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/competitor/metrics/overall_performance?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getKeyMetricsPerformanceDownload: (data: any, language:string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/competitor/metrics/overall_performance/download?language=${language}`,
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        rawData: true,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getKeyMetricsPerformanceXh: (data: any, language:string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/competitor/xh/metrics/overall_performance?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getKeyMetricsPerformanceDownloadXh: (data: any, language:string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/competitor/xh/metrics/overall_performance/download?language=${language}`,
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        rawData: true,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

export const getSelectorList: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/competitor/selector',
        method: 'post',
        data,
    }
    return dashboardRequest(options)
};





